import React, { useEffect, useState } from "react";
import SinglePost from "./SinglePost";
import LoaderSpinner from "../../component/LoaderSpinner";

export default function Blogs() {
  const [blogs, setBlogs] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let isMounted = true;
    const controller = new AbortController();
    
    window.scrollTo(0, 0);
    
    axios.get("api/get_blog_list", { signal: controller.signal }).then((res) => {
      if (!isMounted) return; //Guard skip state if unmounted
      if (res.data.status == "success") {
        setBlogs(res.data.data);
      } else {
        setBlogs([]);
      }
      setLoading(false);
    }).catch(error => {
      if (!isMounted) return;
      if (error.name !== "AbortError"  && error.name !== "CanceledError") {
        console.error("Failed to load blogs:", error);
        setLoading(false);
      }
    });

    // Cleanup: cancel request if component unmounts
    return () => {
      isMounted = false;
      controller.abort();
    };
  }, []);
  return (
    <div className="">
      {loading ? (
        <LoaderSpinner />
      ) : (
        <div className="section-full p-t120  p-b90 site-bg-light">
          <div className="container">
            <div className="row">
              <div className="col-lg-12 col-md-12">
                <div className="masonry-wrap row d-flex">
                  {blogs.length > 0
                    ? blogs.map((blog) => (
                        <SinglePost blog={blog} key={blog.id} />
                      ))
                    : ""}

                  {/* <div className="pagination-outer">
                    <div className="pagination-style1">
                      <ul className="clearfix">
                        <li className="prev">
                          <a href="javascript:;">
                            <span>
                              {" "}
                              <i className="fa fa-angle-left"></i>{" "}
                            </span>
                          </a>
                        </li>
                        <li>
                          <a href="javascript:;">1</a>
                        </li>
                        <li className="active">
                          <a href="javascript:;">2</a>
                        </li>
                        <li>
                          <a href="javascript:;">3</a>
                        </li>
                        <li>
                          <a className="javascript:;" href="javascript:;">
                            <i className="fa fa-ellipsis-h"></i>
                          </a>
                        </li>
                        <li>
                          <a href="javascript:;">5</a>
                        </li>
                        <li className="next">
                          <a href="javascript:;">
                            <span>
                              {" "}
                              <i className="fa fa-angle-right"></i>{" "}
                            </span>
                          </a>
                        </li>
                      </ul>
                    </div>
                  </div> */}
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
